export * from '@erp/ui/label';
